import { GridColumn } from "@glideapps/glide-data-grid";

/**
 * Procesa los valores pegados para transformarlos en una estructura de datos.
 * * @param target [columna, fila] de inicio del pegado.
 * @param values Matriz (array de arrays) de valores pegados.
 * @param getCellContent Función para obtener el contenido de la celda.
 * @param columns Array de definiciones de columna.
 * @param addRows Array de datos de filas adicionales (para obtener el ID).
 * @returns Matriz de datos procesados (pastedData).
 */
export const processPastedValues = (
    target,
    values,
    getCellContent,
    columns,
    addRows
) => {
    const [col, row] = target;
    const pastedData:any[] = [];

    values.forEach((rowVals, dr) => {
        const rowArr: any[] = [];
        let rowIdAdded = false;

        rowVals.forEach((val, dc) => {
            const cc = col + dc;
            const colDef = columns[cc];
            const id = addRows[row + dr]?.id;
            let value = val?.toString().trim();

            if (value) {
              value = value
                .replace(/[\n\r]+/g, " ") // Reemplaza saltos de línea por espacio
                .replace(/[^\S\r\n]+/g, " ") // Normaliza espacios múltiples
                .trim(); // Quita espacios al inicio y final;
            }

            if (!rowIdAdded) {
                rowArr.push({ id });
                rowIdAdded = true;
            }

            if (colDef && colDef.id) {
                rowArr.push({ [colDef.id]: value });
            }
        });

        pastedData.push(rowArr);
    });

    return pastedData;
};

/**
 * Retorna una función de manejo de redimensionamiento de columnas (handleColumnResize).
 * Esta función se debe usar con React.useCallback en el componente.
 * * @param setColumns Función de setState de React para actualizar el array de columnas.
 * @returns Función que maneja el evento onColumnResize.
 */
export const handleColumnResizeUtil = (
  setColumns: React.Dispatch<React.SetStateAction<GridColumn[]>>
) => {
  return (column: GridColumn, newSize: number, colIndex: number, newSizeWithGrow: number) => {
    setColumns(prevCols => {
      if (colIndex < 0 || colIndex >= prevCols.length) return prevCols;
      const newCols = prevCols.slice();
      newCols[colIndex] = { ...newCols[colIndex], width: newSize };
      return newCols;
    });
  };
};

export const saveOnSessionStorageDataTable = (data: any[]) => {
  sessionStorage.setItem('dataTable', JSON.stringify(data));
};

export const getSessionStorageDataTable = (): any[] | null => {
  const stored = sessionStorage.getItem("dataTable");
  if (!stored) return null;

  try {
    return JSON.parse(stored);
  } catch (e) {
    console.warn("Error al parsear dataTable desde sessionStorage:", e);
    return null;
  }
};
